import { capitalize } from '@/utils/helpers'

export const squads = ['a', 'b', 'c', 'd', 'e', 'g', 'i', 'j', 'k', 'l'] as const

export type Squad = (typeof squads)[number]

export const isSquad = (squad: string): squad is Squad => squads.includes(squad as Squad)

export const toSquadLabel = (squad: Squad): string => capitalize(squad)

export const toSquad = (squad: string): Squad | undefined => {
  switch (squad) {
    case 'Group A':
      return 'a'
    case 'Group B':
      return 'b'
    case 'Group C':
      return 'c'
    case 'Group D':
      return 'd'
    case 'Group E':
      return 'e'
    case 'Group G':
      return 'g'
    case 'Group I':
      return 'i'
    case 'Group J':
      return 'j'
    case 'Group K':
      return 'k'
    case 'Group L':
      return 'l'
  }
}

export const toSquads = (squads?: string[]): Squad[] =>
  (squads ?? []).map(toSquad).filter(Boolean) as Squad[]

export const toSquadsLabel = (squads?: Squad[]) => {
  if (squads?.length === undefined || squads.length === 0) {
    return 'None'
  }

  return squads
    .map(toSquadLabel)
    .sort((a, b) => a.localeCompare(b))
    .join(', ')
}
